import React, { createContext, useEffect, useState } from "react";
import GetCookie from '../hooks/getCookie'
import RemoveCookie from "../hooks/removeCookie";
import SetCookie from "../hooks/setCookie";
const AuthContext = createContext();

// const auth={
//   roles:[101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,200,500,501,801,301,302,303,304,305,350,351,352,353,354,400,401,
//     402,403,404,450,451,452,600,601,602,700,750,900],
//   accessToken:'access',
//   refreshToken:'refresh'
// }
// const guest={
//   roles:[],
//   accessToken:'access',
//   refreshToken:'refresh'
// }
export function AuthContextProvider({ children }) {
  const auth=GetCookie('auth')
  const [changed,setChanged]=useState(false)
  const [user, setUser] = useState(auth?JSON.parse(auth):null);
  useEffect(()=>{
    user!==undefined && SetCookie('auth',JSON.stringify(user));
    // console.log(auth?JSON.parse(auth):null)
  },[user])
  useEffect(()=>{
    setUser(auth?JSON.parse(auth):null)
    // console.log(auth?JSON.parse(auth):null)
  },[changed])
  return (
    <AuthContext.Provider value={{ user, setUser,changed,setChanged }}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthContext;
